{
  "close": "Close",
  "sidebar": {
    "toggle": "Toggle Sidebar",
    "title": "Sidebar",
    "description": "Displays the mobile sidebar."
  },
  "or": "or",
  "changeLanguage": "Language",
  "locales": {
    "en": "English",
    "es_MX": "Español (México)"
  },
  "form": {
    "saveFailed": "Something went wrong. Please try again."
  },
  "error": {
    "title": "Oops, We Dropped One",
    "body": "This shouldn’t have happened. And yet, here we are.",
    "report": "Tell Us What You Saw",
    "home": "Go Home"
  },
  "contact": {
    "name": "Your name",
    "email": "Your email",
    "company": "Your company",
    "message": "How can we help you?",
    "send": "Send Message",
    "sent": "Message sent! We'll get back to you soon."
  }
}
